import Link from 'next/link'
import styled from 'styled-components'
import { CDNImage } from '~/components/business/CDNImage'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { useAuth } from '~/hooks/useAuth'
import { MessageEntry } from '~/components/pages/message/MessageEntry'
import { MyContainer } from '~/components/ui/MyContainer'
import { MyBtn } from '~/components/ui/MyBtn'
import { useStores } from '~/hooks/useStores'
import { observer } from 'mobx-react-lite'
import { Dropdown, message } from 'antd'
import { UserEntry } from '~/components/pages/user/UserEntry'
import { MenuOutlined } from '@ant-design/icons'
import { MyLink } from '~/components/ui/MyLink'

export type HeaderType = 'no-margin' | 'normal'

const StyledHeader = styled.header<{
  type: HeaderType
}>`
  background: ${props => props.theme['neutral-100']};
  height: 56px;
  padding: 12px 0;
  z-index: 999;
  top: 0;
  position: sticky;
  ${props =>
    props.type === 'normal' &&
    `border-bottom: 1px solid ${props.theme['neutral-300']}`};
  ${props => props.type === 'normal' && 'margin-bottom: 24px'};
`

const navData = [
  {
    name: '首页',
    href: '/',
    exist: true,
  },
  {
    name: 'AI创作',
    href: '/ai',
    exist: true,
    isHot: true,
  },
  {
    name: 'AI大赛',
    href: '/ai-competition',
    exist: true,
  },
  {
    name: 'AI广场',
    href: '/plaza',
    exist: true,
  },
  {
    name: '咒语生成器',
    href: '/tag-generator',
    exist: true,
  },
  {
    name: 'AI实验室',
    href: '/lab',
    exist: true,
    isNew: true,
  },
  {
    name: 'AI专业版',
    href: '/pro',
    exist: true,
  },
]

const links = [
  {
    label: (
      <a
        className="flex items-center text-xs py-1"
        href="https://wujiebantu.com"
        target="_blank"
        rel="noreferrer"
      >
        <CDNImage className="w-5 mr-2" src="/images/wujie@2x.png" /> 无界版图
      </a>
    ),
    key: 'wujiebantu',
  },
]

export const Header: React.FC<{ type: HeaderType; className?: string }> =
  observer(({ type, className }) => {
    const router = useRouter()
    const { isLogin } = useAuth()
    const { store } = useStores()

    const onLogin = () => {
      store.modal?.setLoginVisible(true)
    }

    return (
      <StyledHeader type={type} className={className}>
        <MyContainer className="flex justify-between items-center">
          <div className="flex items-center">
            <Link href="/">
              <CDNImage src="/images/logo-1.svg" className="h-8 w-[83px]" />
            </Link>
            <div className="border-l-[2px] border-neutral-300 h-8 ml-6 mr-3"></div>
            <ul className="mb-0 flex font-semibold">
              {navData.map(item => (
                <li
                  key={item.href}
                  className="text-[14px] leading-4 px-3 relative"
                >
                  <MyLink
                    href={item.href}
                    exist={item.exist}
                    className={classNames(' hover:text-neutral-800', [
                      router.pathname === item.href
                        ? 'text-neutral-800'
                        : 'text-neutral-400',
                    ])}
                  >
                    {item.name}
                    {item.isNew && (
                      <div className="absolute right-2 -top-4">
                        <img
                          className="h-[14px]"
                          src="/images/new.png"
                          alt=""
                        />
                      </div>
                    )}
                    {item.isHot && (
                      <div className="absolute right-2 -top-4">
                        <img
                          className="h-[14px]"
                          src="/images/hot.png"
                          alt=""
                        />
                      </div>
                    )}
                  </MyLink>
                </li>
              ))}
              {['开放模型'].map(item => (
                <li
                  key={item}
                  className="text-[14px] leading-4 px-3 cursor-pointer"
                  onClick={() => {
                    message.destroy()
                    message.info('敬请期待')
                  }}
                >
                  <span className="text-neutral-400">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex items-center">
            {isLogin ? (
              <>
                <MessageEntry />
                <UserEntry />
              </>
            ) : (
              <>
                <MyBtn
                  className="!h-8 !leading-4 !py-[6px]"
                  $dark
                  onClick={onLogin}
                >
                  登录 / 注册
                </MyBtn>
              </>
            )}
            <Dropdown
              menu={{ items: links }}
              placement="bottomRight"
              trigger={['click']}
              overlayClassName="w-[100px] shodow-dm"
              getPopupContainer={(triggerNode: HTMLElement) =>
                triggerNode.parentNode as HTMLElement
              }
            >
              <MenuOutlined className="!text-neutral-400 hover:!text-primary cursor-pointer ml-6 transition-all" />
            </Dropdown>
          </div>
        </MyContainer>
      </StyledHeader>
    )
  })
